module.exports = "<ul class=\"nav nav-tabs\"> <li role=presentation ng-repeat=\"entry in $ctrl.entries\" ng-class=\"{'active': $ctrl.isActive(entry)}\"> <a ng-if=!entry.hidden class=icon-align-baseline tooltip-popup-delay=500 tooltip-enable=\"{{ !!entry.invalid }}\" uib-tooltip=\"{{ entry.invalid }}\" href=\"\" ng-click=$ctrl.switchToTab(entry) test-sref=\"{{ entry.sref }}\" ng-class=\"{'nav-error': entry.invalid, 'icon-navbar-invalid': entry.invalid}\" role=presentation>{{ entry.title | translate }} </a> </li> </ul> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/navbar/partial.html
// module id = 550
// module chunks = 0